var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 95,
    viewBox: "0 0 85 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 95
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_3",
    "data-name": "Custom Size \\u2013 3",
    clipPath: "url(#clip-Custom_Size_3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(17 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape",
    d: "M50.664,0H0",
    transform: "translate(0 76.022)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M.974,1A.987.987,0,0,1,0,0",
    transform: "translate(24.358 84.024)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle-path",
    width: 50.664,
    height: 92.026,
    rx: 2,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M35.075,14a1.975,1.975,0,0,0-1.95-2H23.383V2a1.975,1.975,0,0,0-1.948-2H13.64a1.975,1.975,0,0,0-1.949,2V12H1.949A1.975,1.975,0,0,0,0,14v8a1.975,1.975,0,0,0,1.949,2h9.743v10a1.975,1.975,0,0,0,1.949,2h7.795a1.975,1.975,0,0,0,1.949-2v-10h9.741a1.975,1.975,0,0,0,1.949-2Z",
    transform: "translate(7.795 20.006)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M.974,0A.987.987,0,0,1,0,1",
    transform: "translate(25.332 84.024)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M0,0A.987.987,0,0,1,.974,1",
    transform: "translate(25.332 83.024)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M0,1A.987.987,0,0,1,.974,0",
    transform: "translate(24.358 83.024)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedical);
export default __webpack_public_path__ + "static/media/icon-medical.cb71097aec30c214a61e2317529aa0b2.svg";
export { ForwardRef as ReactComponent };